export default {
    active: true,
    seed: 8,
    skyType: "gradient",
    skyColor: "#24b59f",
    horizonColor: "#eff9b7",
    lighting: "distant",
    lightPosition: { x: -1.2, y: 0.88, z: -0.55 },
    fog: 0.8,
    flatShading: false,
    playArea: 1,
    ground: "noise",
    groundYScale: 4.18,
    groundTexture: "squares",
    groundColor: "#937a24",
    groundColor2: "#987d2e",
    dressing: "trees",
    dressingAmount: 500,
    dressingColor: "#888b1d",
    dressingScale: 1,
    dressingVariance: { x: 10, y: 10, z: 10 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0,
    grid: "none",
    gridColor: "#c5a543",
    shadow: false,
};
